export default "__VITE_ASSET__892f1a50__"